









import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import ButtonSelect, { ItemType } from './ButtonSelect.vue';
import { Maybe } from '@/types/common';

@Component({
    components: {
        ButtonSelect,
    },
})
export default class ButtonSelectSimple extends Vue {
    @Model('change') value!: string | number;
    @Prop({ type: Array, default: () => ([]) }) items!: ItemType[];

    get modelWrapper() {
        return this.items.find(item => item.id === this.value) ?? null;
    }

    set modelWrapper(value: Maybe<ItemType>) {
        if (value) {
            this.$emit('change', value.id);
        }
    }
}
